import axios from 'axios';

const adminApi = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  withCredentials: true,
});

adminApi.interceptors.response.use(
  (response) => response,
  (error) => {
    const isLoginRequest = error.config?.url?.includes('/api/admin/login');
    if (error.response?.status === 401 && !isLoginRequest && window.location.pathname !== '/admin/login') {
      window.location.href = '/admin/login';
    }
    return Promise.reject(error);
  }
);

export default adminApi;
